import { createContext, useContext } from "react";
import { type CollectionClient, collectionClient } from "service/collections";

/** Lets tests and stories inject their own client; the app uses the default. */
export const CollectionClientContext =
  createContext<CollectionClient>(collectionClient);

export const useCollectionClient = () => useContext(CollectionClientContext);
